import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";

const LinkWithQuery = ({ children, to, hash = "", show = "", ...props }) => {
  let { search } = useLocation();

  if (show) search += `&show=${show}`;

  return (
    <Link
      to={{
        pathname: to,
        search,
        ...(hash && {
          hash,
        }),
      }}
      prefetch="render"
      relative="route"
      {...props}
    >
      {children}
    </Link>
  );
};
LinkWithQuery.propTypes = {
  to: PropTypes.string.isRequired,
  hash: PropTypes.string,
  show: PropTypes.string,
};

export default LinkWithQuery;
